var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWholesaleOrder4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.17,
    y: 47.45,
    width: 183.66,
    height: 123.66,
    rx: 13.42,
    ry: 13.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.17,
    y: 67.37,
    width: 183.66,
    height: 29.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 73.88,
    y: 145.4,
    width: 45.94,
    height: 11.07,
    rx: 5.01,
    ry: 5.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.05,
    y: 77.6,
    width: 183.66,
    height: 123.66,
    rx: 13.42,
    ry: 13.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.05,
    y: 97.51,
    width: 183.66,
    height: 29.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.76,
    y: 175.55,
    width: 45.94,
    height: 11.07,
    rx: 5.01,
    ry: 5.01
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.36,254.25l10.11-6.06c1.22-.73,2.73-.73,3.95,0l13.95,8.36c1.22,.73,2.73,.73,3.95,0l13.95-8.36c1.22-.73,2.73-.73,3.95,0l13.95,8.36c1.22,.73,2.73,.73,3.95,0l13.95-8.36c1.22-.73,2.73-.73,3.95,0l10.11,6.06c2.56,1.53,5.81-.31,5.81-3.29V121.63c0-9.15-7.42-16.57-16.57-16.57h-107.34l16.51,65.77v80.13c0,2.98,3.26,4.83,5.81,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.04,105.06h0c9.11,0,16.51,7.4,16.51,16.51v74.43c0,1.46-1.19,2.65-2.65,2.65h-27.72c-1.46,0-2.65-1.19-2.65-2.65V121.57c0-9.11,7.4-16.51,16.51-16.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.28,
    y: 134.24,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.28,
    y: 163.94,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.28,
    y: 193.64,
    width: 60.59,
    height: 8.14,
    rx: 4.07,
    ry: 4.07
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 127.23,
    cy: 211.29,
    r: 35.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "110.28 211.97 121.13 222.82 144.18 199.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleOrder4);
export default __webpack_public_path__ + "static/media/wholesale_order_4.08140ae7e44bf81788b18c2d6b3676c1.svg";
export { ForwardRef as ReactComponent };